import { render, staticRenderFns } from "./LevelsAndPoints.vue?vue&type=template&id=0033a114&scoped=true"
import script from "./LevelsAndPoints.vue?vue&type=script&lang=js"
export * from "./LevelsAndPoints.vue?vue&type=script&lang=js"
import style0 from "./LevelsAndPoints.vue?vue&type=style&index=0&id=0033a114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0033a114",
  null
  
)

export default component.exports